import React from "react";
import classnames from "classnames";

import { getDistance } from "utils/distance";

import StoreFrontIcon from "components/Icons/storefront.svg";
import Image from "components/Image";

export interface Props {
  // TODO Can't use api-og def here because this data may come from a ES index,
  // TODO which has a different data shape than our db table.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  dispensary: any;
  /**
   * showCarouselInfo is an optional prop for displaying dispensary information on carousel cards.
   */
  showCarouselInfo?: boolean;
}

const DispensaryPickupFulfillmentInfo: React.FC<Props> = ({
  dispensary,
  showCarouselInfo = false,
}) => {
  const {
    country,
    distanceMi,
    logoImage,
    logoUrl,
    name: dispensaryName,
  } = dispensary || {};

  const dispensaryImage =
    logoImage ||
    logoUrl ||
    "https://public.leafly.com/dispensary/static/placeholder-dispensary-photo.jpg";

  return (
    <>
      <div
        className={classnames("gap-2 mt-xs", {
          flex: showCarouselInfo,
          "hidden md:flex": !showCarouselInfo,
        })}
        data-testid="menu-item-card__fulfillment"
      >
        <div
          className="flex-shrink-0 border rounded border-grey-44"
          style={{ height: "24px", width: "24px" }}
        >
          <Image
            src={dispensaryImage}
            alt={dispensaryName}
            sizes={[24]}
            className="rounded"
          />
        </div>
        <div
          className="flex flex-col truncate font-bold text-xs"
          data-testid="menu-item-card__pickup-info"
        >
          <div className="truncate">{dispensaryName}</div>
          <span className="truncate">
            {`Pickup ${getDistance(distanceMi, country, true)} away`}
          </span>
        </div>
      </div>
      {!showCarouselInfo && (
        <div
          className={"md:hidden mt-xs p-xs bg-leafly-white rounded w-full"}
          data-testid="menu-item-card__fulfillment-mobile"
        >
          <div className="flex items-center font-bold text-xs">
            <span className="mr-xs">
              <StoreFrontIcon width="16" height="16" />
            </span>
            <div
              className="flex flex-col truncate font-bold text-xs"
              data-testid="menu-item-card__pickup-info-mobile"
            >
              <span className="truncate">
                {`${getDistance(distanceMi, country, false)} away`}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DispensaryPickupFulfillmentInfo;
